import { Row, Col } from "react-bootstrap";
import { LogotypeBelkaDolna } from "wup-module1-base";

function Footer() {
  return (
    <div className="footer">
      <div className="logotypes-container">
        <Row className="m-0 justify-content-center">
          <Col xs={12} md={12} className="my-auto">
            <img
              className="logotype"
              src={LogotypeBelkaDolna}
              alt="Logo MAŁOPOLSKI POCIĄG DO KARIERY"
            />
          </Col>
        </Row>
      </div>
      <div className="main-footer">
        <Row className="m-0 main-footer-row">
          <Col lg={"auto"} className="my-auto ">
            <div className="mb-4 mt-4">
              <p>
                <b>Wojewódzki Urząd Pracy w Krakowie</b>
              </p>
              <p>Plac Na Stawach 1, 30-107 Kraków</p>
            </div>

            <div className="mb-4">
              <p>
                <b>Obsługa klienta:</b>
              </p>
              <p>
                <b>Numer telefonu (od 8:00 do 16:00):</b>
              </p>
              <p>
                <b>12 424 07 38</b>
              </p>
              <p>
                e-mail:{" "}
                <b className="text-footer-orange">kariera@wup-krakow.pl</b>
              </p>
            </div>

            <div className="mb-4">
              <p className="footer-hashtag-container">
                <span className="footer-hashtag">#FunduszeUE</span>
                <span className="footer-hashtag">#FunduszeEuropejskie</span>
              </p>
            </div>
          </Col>
        </Row>
      </div>
    </div >
  );
}

export default Footer;
